const listenToFirstFormFieldUpdate = require("../form/listenToFirstFormFieldUpdate");

/**
 * @param onUpdated {(countryField: HTMLElement) => void}
 * @return {void}
 */
module.exports = function listenToFirstRoiGateFormCountryFieldUpdate(onUpdated) {
    const selector = '[data-component="roi-calculator-gate-form"] [name="Country"]';
    listenToFirstFormFieldUpdate(selector, onUpdated);
}